import { getEditorDims } from '../../panelsEditorHelper';
import { getStage } from '../stage/stage';
import { markStageDirty } from '../stage/stageDirty';
import { isEdge } from '__common/utils/browserDetector';
import { mousePosition } from '../cursor/cursor';

export type MoveMapPoint = {
  x: number;
  y: number;
};

let moveMapStart: MoveMapPoint | null = null;

export function startMovingMap(position?: MoveMapPoint) {
  if (!moveMapStart) {
    moveMapStart = {
      x: position?.x ?? mousePosition().x,
      y: position?.y ?? mousePosition().y,
    };
  }
}

export function moveMap(position?: MoveMapPoint) {
  if (!moveMapStart) {
    return;
  }

  document.body.style.cursor = '-webkit-grabbing';
  const currPosition = {
    x: position?.x ?? mousePosition().x,
    y: position?.y ?? mousePosition().y,
  };

  const stage = getStage();

  const modi = isEdge() ? 0.15 : 1;
  const xDiff = (currPosition.x - moveMapStart.x) * modi;
  const yDiff = (currPosition.y - moveMapStart.y) * modi;

  const editorDims = getEditorDims();

  if (
    stage.x + xDiff < 0 &&
    stage.x - editorDims.width > -(editorDims.width * stage.scale.x) - xDiff
  ) {
    stage.x += xDiff;
    markStageDirty();
  }

  if (
    stage.y + yDiff < 0
     &&
    stage.y - editorDims.height > -(editorDims.height * stage.scale.y) - yDiff
  ) {
    stage.y += yDiff;
    markStageDirty();
  }

  moveMapStart = currPosition;

  return;
}

export function endMovingMap() {
  document.body.style.cursor = '-webkit-grab';
  moveMapStart = null;
  return;
}

export function isMovingMapInitied() {
  return moveMapStart !== null;
}
